import { render, staticRenderFns } from "./ServiceProviderUsers.vue?vue&type=template&id=67fe9382&scoped=true&"
import script from "./ServiceProviderUsers.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe9382",
  null
  
)

export default component.exports